import React, { Component } from 'react';  
import { Picker, List, Toast } from 'antd-mobile/lib';
import { 
	userJob,
	getUserJob,
	provinceCity,
	getProvinceCity,
	smrzCardPerson,
	smrzPersonNumber,
	smrzAddress,
	smrzJob,
	smrzCareerCode,
	smrzCity,
	smrzBeneficiaries,
	smrzBeneficiariesName,
	smrzBeneficontro,
	smrzBeneficontroName,
	smrzBeneficiariesType,
	smrzBeneficontroType,
	smrzBeneficiariesNo,
	smrzBeneficontroNo,
	smrzGjzz,
	smrzCardNumber
} from '../../action/investmentAction.js';
import { connect } from 'react-redux';
import NavigatorMain from '../NavigatorMain.js';
import { hashHistory } from 'react-router';
import "./css/CertificationCard.css";
import { modifyUserAccount } from '../../action/myAssets/userInfoAction'

/*老用户添加反洗钱信息*/
class AddCertificationCard extends Component {
	state = {
		cardPerson: this.props.smrzCardPerson,
		personNumber: this.props.smrzPersonNumber,
		address: this.props.smrzAddress,
		job: this.props.smrzJob,
		city: this.props.smrzCity,
		beneficiaries: this.props.smrzBeneficiaries,
		beneficiariesName: this.props.smrzBeneficiariesName,
		beneficiariesType: this.props.smrzBeneficiariesType,
		beneficiariesNo: this.props.smrzBeneficiariesNo,
		beneficontro: this.props.smrzBeneficontro,
		beneficontroName: this.props.smrzBeneficontroName,
		beneficontroType: this.props.smrzBeneficontroType,
		beneficontroNo: this.props.smrzBeneficontroNo,
		isImportant: this.props.smrzGjzz,
		phoneNo: this.props.userMobileNo,
		enterType:this.props.location.query.enterType ? this.props.location.query.enterType : null,
		careerCode: this.props.smrzCareerCode
	}

	componentWillMount() {
		window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "进入"]);
		document.getElementsByTagName('title')[0].innerHTML = "实名认证";
		let { dispatch } = this.props;
		dispatch(userJob(null));
		dispatch(provinceCity(null));
		Toast.loading("正在加载");
		dispatch(getProvinceCity((data) => {
			this.setState({
				city: [data[0].provinceCode, data[0].cityList[0].cityCode]
			});
			dispatch(smrzCity([data[0].provinceCode, data[0].cityList[0].cityCode]));
		}, () => {
			
		}));
		dispatch(getUserJob());
		
		console.log(this.props.userInfo,"userInfouserInfouserInfouserInfo****")
	}

	changeJob = (value) => {
		if(value[0]) {
			let { dispatch } = this.props;
			this.setState({
				job: value,
				careerCode: value[0]
			});
			dispatch(smrzCareerCode(value[0]));
			dispatch(smrzJob(value));
		}else {
			let { dispatch } = this.props;
			this.setState({
				job: [this.props.userJob[0].careerId],
				careerCode: this.props.userJob[0].careerId
			});
			dispatch(smrzCareerCode(this.props.userJob[0].careerId));
			dispatch(smrzJob([this.props.userJob[0].careerId]));
		}
	}

	changeCity = (value) => {
		let { dispatch } = this.props;
		this.setState({
			city: value
		});
		dispatch(smrzCity(value));
	}

	changeBeneficiaries = (value) => {
		let { dispatch } = this.props;
		this.setState({
			beneficiaries: value
		});
		dispatch(smrzBeneficiaries(value));
	}

	changeBeneficontro = (value) => {
		let { dispatch } = this.props;
		this.setState({
			beneficontro: value
		});
		dispatch(smrzBeneficontro(value));
	}

	changeBeneficiariesType = (value) => {
		if(value[0]) {
			let { dispatch } = this.props;
			this.setState({
				beneficiariesType: value
			});
			dispatch(smrzBeneficiariesType(value));
		}else {
			let { dispatch } = this.props;
			this.setState({
				beneficiariesType: ["身份证"]
			});
			dispatch(smrzBeneficiariesType(["身份证"]));
		}
	}

	changeBeneficontroType = (value) => {
		if(value[0]) {
			let { dispatch } = this.props;
			this.setState({
				beneficontroType: value
			});
			dispatch(smrzBeneficontroType(value));
		}else {
			let { dispatch } = this.props;
			this.setState({
				beneficontroType: ["身份证"]
			});
			dispatch(smrzBeneficontroType(["身份证"]));
		}
	}

	changeIsImportant = (value) => {
		let { dispatch } = this.props;
		this.setState({
			isImportant: value
		});
		dispatch(smrzGjzz(value));
	}

	goCertification = () => {
		let { dispatch } = this.props;
		let { phoneNo, personNumber, beneficiariesName, beneficiaries, beneficontroName, beneficontro, beneficiariesType, beneficontroType, beneficiariesNo, beneficontroNo, isImportant, address, job, city, careerCode } = this.state;
		let regName = /^([\u4e00-\u9fa5]){2,7}$/;
		let regNo =  /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|X)$/i;
		let regAddress = /[\u4e00-\u9fa5]+/i;
		// if(!regName.test(cardPerson)) {
		// 	Toast.info( "请输入正确格式的持卡人", 2);
		// 	return ;
		// }
		// if(!regNo.test(personNumber)) {
		// 	Toast.info( "请输入正确格式的身份证号", 2);
		// 	return ;
		// }
		// if(cLength(address) < 4) {
		// 	Toast.info( "详细地址不能少于4个汉字", 2);
		// 	return ;
		// }
		console.log(careerCode,"careerCodecareerCode请选择职业请选择职业",!careerCode)
		if(careerCode[0]=="") {
			Toast.info( "请选择职业", 2);
			return ;
		}
		if(beneficontro == "他人") {
			if(!regName.test(beneficontroName)) {
				Toast.info( "请输入正确格式的控制人姓名", 2);
				return ;
			}
			if(!beneficontroType) {
				Toast.info( "请选择控制人证件类型", 2);
				return ;
			}
			if(!beneficontroNo) {
				Toast.info( "请输入控制人证件号", 2);
				return ;
			}
			if(beneficontroType == '身份证' && !regNo.test(beneficontroNo)){
				Toast.info('请输入正确格式的控制人身份证号', 2);
				return;
			}
		}
		if(beneficiaries == "他人") {
			if(!regName.test(beneficiariesName)) {
				Toast.info( "请输入正确格式的受益人姓名", 2);
				return ;
			}
			if(!beneficiariesType) {
				Toast.info( "请选择受益人证件类型", 2);
				return ;
			}
			if(!beneficiariesNo) {
				Toast.info( "请输入受益人证件号", 2);
				return ;
			}
			if(beneficiariesType == '身份证' && !regNo.test(beneficiariesNo)){
				Toast.info('请输入正确格式的受益人身份证号', 2);
				return;
			}
		}
		// let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
  //   	let callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
		let theNo = {
			"身份证": "0",
			"护照": "1",
			"户口本": "5",
			"警官证": "a",
			"文职证": "b",
			"港澳居民来往内地通行证(原回乡证)": "4",
			"台胞证": "A"
		}
		// hashHistory.push({
		// 	pathname: "/certificationCardAgain",
		// 	state: {
		// 		name: cardPerson,
		// 		certNo: personNumber.toUpperCase(),
		// 		certType: 0,
		// 		address: address,
		// 		careerCode: careerCode,
		// 		cityCode: city[1],
		// 		provinceCode: city[0],
		// 		actualBeneficiary: beneficiaries == "本人" ? cardPerson : beneficiariesName,
		// 		actualController: beneficontro == "本人" ? cardPerson : beneficontroName,
		// 		actualBeneficiaryCertType: beneficiariesType ? theNo[beneficiariesType] : beneficiariesType,
		// 		actualBeneficiaryCertNo: beneficiariesNo,
		// 		actualControllerCertType: beneficontroType ? theNo[beneficontroType] : beneficontroType,
		// 		actualControllerCertNo: beneficontroNo,
		// 		officialsOrRelatives: isImportant == "是" ? true : false, 
		// 		phoneNo: phoneNo,
		// 		callback: callback,
		// 		route: route,
		// 		enterType:this.state.enterType
		// 	},
		// 	query: {enterType:this.state.enterType}
		// })
		dispatch(smrzCardNumber(""));
		let userInfo = this.props.userInfo && this.props.userInfo.content;

		let cardPerson = userInfo.name;
		let certNo = userInfo.certNo;
		let certType = userInfo.certType;


		let params = {
			name: cardPerson,
			profession: careerCode,/*职业代码*/
			actualBeneficiary: beneficiaries == "本人" ? cardPerson : beneficiariesName,
			actualController: beneficontro == "本人" ? cardPerson : beneficontroName,

			// actualBeneficiaryCertType: beneficiaries == "本人" ? certType : ( beneficiariesType ? theNo[beneficiariesType] : beneficiariesType ),
			// actualBeneficiaryCertNo: beneficiaries == "本人" ? certNo : beneficiariesNo,
			// actualControllerCertType: beneficontro == "本人" ? certType : beneficontroType ? theNo[beneficontroType] : beneficontroType,
			// actualControllerCertNo: beneficontro == "本人" ? certNo : beneficontroNo,
			// isOfficialsOrRelatives: isImportant == "是" ? true : false, 

			actualBeneficiaryCertType: beneficiariesType ? theNo[beneficiariesType] : "0",
			actualBeneficiaryCertNo: beneficiaries == "本人" ? certNo : beneficiariesNo,
			actualControllerCertType: beneficontroType ? theNo[beneficontroType] : "0",
			actualControllerCertNo: beneficontro == "本人" ? certNo : beneficontroNo,
			isOfficialsOrRelatives: isImportant == "是" ? true : false, 
			sex:"",
			email:"",
			contactAddress: "",

		}
		console.log(params,"paramspara8888msparams")																				
		this.props.dispatch(modifyUserAccount(params,this.callback))
	}
	callback = (res) => {
		let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
    	let callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
		if(route) {
            hashHistory.go(-1);
         }
	}
	changeCardPerson = (event) => {
		let { dispatch } = this.props;
		this.setState({
			cardPerson :event.target.value
		})
		dispatch(smrzCardPerson(event.target.value));
	}

	changeBeneficiariesName = (event) => {
		let { dispatch } = this.props;
		this.setState({
			beneficiariesName: event.target.value
		});
		dispatch(smrzBeneficiariesName(event.target.value));
	}	

	changeBeneficontroName = (event) => {
		let { dispatch } = this.props;
		this.setState({
			beneficontroName: event.target.value
		});
		dispatch(smrzBeneficontroName(event.target.value));
	}	

	changeBeneficiariesNo = (event) => {
		let { dispatch } = this.props;
		this.setState({
			beneficiariesNo: event.target.value
		});
		dispatch(smrzBeneficiariesNo(event.target.value));
	}	

	changeBeneficontroNo = (event) => {
		let { dispatch } = this.props;
		this.setState({
			beneficontroNo: event.target.value
		});
		dispatch(smrzBeneficontroNo(event.target.value));
	}	

	changePersonNumber = (event) => {
		let { dispatch } = this.props;
		this.setState({
			personNumber :event.target.value
		})
		dispatch(smrzPersonNumber(event.target.value));
	}

	changeAddress = (event) => {
		let { dispatch } = this.props;
		this.setState({
			address :event.target.value
		})
		dispatch(smrzAddress(event.target.value));
	}
	goBack = () => {
		window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "回退"]);
		hashHistory.goBack();
	}
	componentWillUnmount() {
		window._czc.push(["_trackEvent", "华夏财富H5", "实名认证", "退出"]);
	}
	render() {
		let { cardPerson, personNumber, city, address, job, downUpListShow, beneficiariesName, beneficiaries, beneficontroName, beneficontro, beneficiariesType, beneficontroType, beneficiariesNo, beneficontroNo, isImportant, downListFlag } = this.state;
		let btnArr = [];
		let jobArr = [];
		let cityArr = [];
		let { provinceCity, userJob } = this.props;
		if(userJob != null) {
			for(let i = 0; i < userJob.length; i++) {
				jobArr.push({label: userJob[i].careerName, value: userJob[i].careerId});
			}
		}
		if(provinceCity != null) {
			for(let i = 0; i < provinceCity.length; i++) {
				let obj = {};
				let obj2 = [];
				obj.label = provinceCity[i].provinceName;
				obj.value = provinceCity[i].provinceCode;
				for(let k = 0; k < provinceCity[i].cityList.length; k++) {
					obj2.push({
						label: provinceCity[i].cityList[k].cityName,
						value: provinceCity[i].cityList[k].cityCode
					});
				}
				obj.children = obj2;
				cityArr.push(obj);
			}
		}
		let beneficiariesArr = [{value: "本人", label: "本人"}, {value: "他人", label: "他人"}];
		let beneficontroArr = [{value: "本人", label: "本人"}, {value: "他人", label: "他人"}];
		let beneficiariesTypeArr = [{value: "身份证", label: "身份证"}, {value: "护照", label: "护照"}, {value: "户口本", label: "户口本"}, {value: "警官证", label: "警官证"}, {value: "文职证", label: "文职证"}, {value: "港澳居民来往内地通行证(原回乡证)", label: "港澳居民来往内地通行证(原回乡证)"}, {value: "台胞证", label: "台胞证"}];
		let beneficontroTypeArr = [{value: "身份证", label: "身份证"}, {value: "护照", label: "护照"}, {value: "户口本", label: "户口本"}, {value: "警官证", label: "警官证"}, {value: "文职证", label: "文职证"}, {value: "港澳居民来往内地通行证(原回乡证)", label: "港澳居民来往内地通行证(原回乡证)"}, {value: "台胞证", label: "台胞证"}];
		let gjzzArr = [{value: "是", label: "是"}, {value: "否", label: "否"}];
		if( job && beneficontro == "本人" && beneficiaries == "本人" && isImportant) {
			btnArr.push(
				<div 
				className="smrz-first-okbtn"
				key={0}
				onClick={this.goCertification}
				>
					<div>下一步</div>
				</div>
			);
		}else if(job && beneficontro == "他人" && beneficiaries == "本人" && isImportant) {
			if(beneficontroName && beneficontroType && beneficontroNo) {
				btnArr.push(
					<div 
					className="smrz-first-okbtn"
					key={0}
					onClick={this.goCertification}
					>
						<div>下一步</div>
					</div>
				);
			}else {
				btnArr.push(
					<div 
					className="smrz-first-unokbtn"
					key={0}
					>
						<div>下一步</div>
					</div>
				);
			}
		}else if(job && beneficiaries == "他人" && beneficontro == "本人" && isImportant) {
			if(beneficiariesName && beneficiariesType && beneficiariesNo) {
				btnArr.push(
					<div 
					className="smrz-first-okbtn"
					key={0}
					onClick={this.goCertification}
					>
						<div>下一步</div>
					</div>
				);
			}else {
				btnArr.push(
					<div 
					className="smrz-first-unokbtn"
					key={0}
					>
						<div>下一步</div>
					</div>
				);
			}
		}else if(job && beneficiaries == "他人" && beneficontro == "他人" && isImportant) {
			if(beneficiariesName &&  beneficontroName && beneficiariesType && beneficontroType && beneficiariesNo && beneficontroNo) {
				btnArr.push(
					<div 
					className="smrz-first-okbtn"
					key={0}
					onClick={this.goCertification}
					>
						<div>下一步</div>
					</div>
				);
			}else {
				btnArr.push(
					<div 
					className="smrz-first-unokbtn"
					key={0}
					>
						<div>下一步</div>
					</div>
				);
			}
		}else {
			btnArr.push(
				<div 
				className="smrz-first-unokbtn"
				key={0}
				>
					<div>下一步</div>
				</div>
			);
		}
		return (
			<div className="mainBox"> 
		        <NavigatorMain>
		          <div className="boxHeader">
		            <div>
		              <img onClick={this.goBack} src={require("../../img/leftArrow_header.png")} />
		            </div>
		            <div>
		              <span>实名认证</span>
		            </div>
		            <div>
		              
		            </div>
		          </div>
		        </NavigatorMain> 
		        <div className="boxContent">
					<div style={{paddingLeft: 13, paddingRight: 13, paddingTop: 20, paddingBottom: 10}}>
						<div style={{fontSize: "13px", color: "#5b6370"}}>根据证监会销售适当性要求，请如实填写个人信息，以便于为您提供更好的安全保障</div>
					</div>
					<div className={job[0] ? "pickerBox" : "pickerBox pickerBox6"} style={{
						display: "-webkit-flex",
						height: 45,
				    	backgroundColor: "#fff",
				    	paddingLeft: 13,
				    	paddingRight: 13,
				    	WebkitAlignItems: "center",
				    	WebkitFlexDirection: "row",
				    	borderBottom: "1px solid rgb(235, 238, 240)",
					}}>
						<Picker value={job} title="职业列表" data={jobArr} extra="请选择职业" onChange={this.changeJob} cols={1} className="forss">
		                  <List.Item arrow="horizontal">职业</List.Item>
		                </Picker>
					</div>
					<div className="pickerBox" style={{
						display: "-webkit-flex",
						height: 45,
				    	backgroundColor: "#fff",
				    	paddingLeft: 13,
				    	paddingRight: 13,
				    	WebkitAlignItems: "center",
				    	WebkitFlexDirection: "row",
				    	borderBottom: "1px solid rgb(235, 238, 240)",
					}}>
						<Picker value={beneficontro} title="账户实际控制人" data={beneficontroArr} onChange={this.changeBeneficontro} cols={1} className="forss">
		                  <List.Item arrow="horizontal">账户实际控制人</List.Item>
		                </Picker>
					</div>
					{
						beneficontro == "本人" || !beneficontro ?
						null :
						<div style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<span style={{
								color: "#5b6370",
								fontSize: "13px",
								width:"40%",
								display: "block"
							}}>
								姓名
							</span>
							<input autocomplete="off"
							style={{
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							}}
							value={beneficontroName}
							onChange={this.changeBeneficontroName}
							placeholder="请输入姓名"
							/>
						</div>
					}
					{
						beneficontro == "本人" || !beneficontro ?
						null :
						<div className={beneficontroType[0] ? "pickerBox" : "pickerBox pickerBox6"} style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<Picker value={beneficontroType} title="证件类型" extra="请选择证件类型" data={beneficontroTypeArr} onChange={this.changeBeneficontroType} cols={1} className="forss">
			                  <List.Item arrow="horizontal">证件类型</List.Item>
			                </Picker>
						</div>
					}
					{
						beneficontro == "本人" || !beneficontro ?
						null :
						<div style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<span style={{
								color: "#5b6370",
								fontSize: "13px",
								width:"40%",
								display: "block"
							}}>
								证件号
							</span>
							<input autocomplete="off"
							style={{
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							}}
							value={beneficontroNo}
							onChange={this.changeBeneficontroNo}
							placeholder="请输入证件号"
							/>
						</div>
					}
					<div className="pickerBox" style={{
						display: "-webkit-flex",
						height: 45,
				    	backgroundColor: "#fff",
				    	paddingLeft: 13,
				    	paddingRight: 13,
				    	WebkitAlignItems: "center",
				    	WebkitFlexDirection: "row",
				    	borderBottom: "1px solid rgb(235, 238, 240)",
					}}>
						<Picker value={beneficiaries} title="账户实际控制人" data={beneficiariesArr} onChange={this.changeBeneficiaries} cols={1} className="forss">
		                  <List.Item arrow="horizontal">账户实际受益人</List.Item>
		                </Picker>
					</div>
					{
						beneficiaries == "本人" || !beneficiaries ?
						null :
						<div style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<span style={{
								color: "#5b6370",
								fontSize: "13px",
								width:"40%",
								display: "block"
							}}>
								姓名
							</span>
							<input autocomplete="off"
							style={{
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							}}
							value={beneficiariesName}
							onChange={this.changeBeneficiariesName}
							placeholder="请输入姓名"
							/>
						</div>
					}
					{
						beneficiaries == "本人" || !beneficiaries ?
						null :
						<div className={beneficiariesType[0] ? "pickerBox" : "pickerBox pickerBox6"} style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<Picker value={beneficiariesType} title="证件类型" extra="请选择证件类型" data={beneficiariesTypeArr} onChange={this.changeBeneficiariesType} cols={1} className="forss">
			                  <List.Item arrow="horizontal">证件类型</List.Item>
			                </Picker>
						</div>
					}
					{
						beneficiaries == "本人" || !beneficiaries ?
						null :
						<div style={{
							display: "-webkit-flex",
							height: 45,
					    	backgroundColor: "#fff",
					    	paddingLeft: 13,
					    	paddingRight: 13,
					    	WebkitAlignItems: "center",
					    	WebkitFlexDirection: "row",
					    	borderBottom: "1px solid rgb(235, 238, 240)",
						}}>
							<span style={{
								color: "#5b6370",
								fontSize: "13px",
								width:"40%",
								display: "block"
							}}>
								证件号
							</span>
							<input autocomplete="off"
							style={{
								width: "60%",
								fontSize: "13px",
								color: "#3a3e47",
								textAlign: 'right'
							}}
							value={beneficiariesNo}
							onChange={this.changeBeneficiariesNo}
							placeholder="请输入证件号"
							/>
						</div>
					}
					<div className="pickerBox pickerBoxTs" style={{
						display: "-webkit-flex",
						height: "auto",
				    	backgroundColor: "#fff",
				    	paddingLeft: 13,
				    	paddingRight: 13,
				    	WebkitAlignItems: "center",
				    	WebkitFlexDirection: "row",
				    	borderBottom: "1px solid rgb(235, 238, 240)",
					}}>
						<Picker value={isImportant} title="请选择是或否" data={gjzzArr} onChange={this.changeIsImportant} cols={1} className="forss">
		                  <List.Item arrow="horizontal">实际受益人为政要、国际组织高级管理人员或其亲属、关系密切的人</List.Item>
		                </Picker>
					</div>
					{
						btnArr
					}
				</div>
			</div>
		)
	}
}

function mapStateToProps(state,ownProps) {
  return {
    userJob: state.userJob,
    provinceCity: state.provinceCity,
    smrzCardPerson: state.smrzCardPerson,
    smrzPersonNumber: state.smrzPersonNumber,
    smrzAddress: state.smrzAddress,
    smrzJob: state.smrzJob,
    smrzCareerCode: state.smrzCareerCode,
    smrzCity: state.smrzCity,
    smrzBeneficiaries: state.smrzBeneficiaries,
	smrzBeneficiariesName: state.smrzBeneficiariesName,
	smrzBeneficiariesType: state.smrzBeneficiariesType,
	smrzBeneficiariesNo: state.smrzBeneficiariesNo,
	smrzBeneficontro: state.smrzBeneficontro,
	smrzBeneficontroName: state.smrzBeneficontroName,
	smrzBeneficontroType: state.smrzBeneficontroType,
	smrzBeneficontroNo: state.smrzBeneficontroNo,
	smrzGjzz: state.smrzGjzz,
    userMobileNo: state.userMobileNo,
    userInfo: state.verifiedUserInfo
  }
}

function cLength(str){
  var reg = /[^\u4E00-\u9FA5\uf900-\ufa2d]/g;
  //匹配非中文的正则表达式
  var temp = str.replace(reg,'');
  return temp.length;
}


export default connect(mapStateToProps)(AddCertificationCard);


// WEBPACK FOOTER //
// ./src/components/recommend/AddCertificationCard.js